export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    skills: 'Skills',
    projects: 'Projects',
    blog: 'Blog',
    contact: 'Contact'
  },
  hero: {
    greeting: 'Hello, I am',
    name: 'Cherif Ibrahima Aïdara Sadio',
    title: 'Full Stack Developer',
    description: 'Passionate about creating innovative web and mobile applications. Expert in React, Node.js, Flutter and modern architectures.',
    cta: 'View my projects',
    contact: 'Contact me'
  },
  about: {
    title: 'About',
    subtitle: 'me',
    intro: 'Passionate Full Stack Developer with 3 years of experience in creating high-performance web and mobile applications.',
    description: 'I specialize in developing complex web applications and scalable architectures. My expertise covers the entire development cycle, from design to production deployment.',
    experience: 'Experience',
    experienceValue: '3 years',
    projects: 'Projects',
    projectsValue: '15+',
    technologies: 'Technologies',
    technologiesValue: '20+'
  },
  skills: {
    title: 'Technical',
    subtitle: 'Stack',
    viewAll: 'View complete skills page',
    categories: {
      frontend: 'Frontend',
      backend: 'Backend',
      mobile: 'Mobile',
      database: 'Databases',
      api: 'API & Web',
      devops: 'DevOps',
      methodologies: 'Methodologies'
    },
    languages: {
      javascript: 'Main language',
      typescript: 'Type-safe',
      python: 'Backend & AI',
      php: 'Dynamic web',
      dart: 'Mobile Flutter'
    }
  },
  projects: {
    title: 'Featured',
    subtitle: 'Projects',
    viewAll: 'View all projects',
    viewProject: 'View project',
    technologies: 'Technologies'
  },
  experience: {
    title: 'Professional',
    subtitle: 'Experience',
    present: 'Present'
  },
  contact: {
    title: 'Contact',
    subtitle: 'me',
    description: 'Have a project in mind? Feel free to contact me to discuss it.',
    form: {
      name: 'Full name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send message',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Error sending message.'
    },
    info: {
      email: 'Email',
      phone: 'Phone',
      location: 'Location'
    }
  },
  blog: {
    title: 'Blog &',
    subtitle: 'Technical Articles',
    description: 'Sharing expertise and experience feedback',
    leadership: 'Leadership & Management',
    companies: 'companies',
    developers: 'developers led',
    readMore: 'Read article',
    readTime: 'min read',
    categories: {
      all: 'All',
      leadership: 'Leadership',
      architecture: 'Architecture',
      devops: 'DevOps',
      management: 'Management',
      backend: 'Backend',
      mobile: 'Mobile'
    }
  },
  footer: {
    rights: 'All rights reserved',
    builtWith: 'Built with',
    social: 'Social media'
  }
};
